import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  private readonly http = inject(HttpClient);

  constructor() { }

  getCustomerById(keycloakId: string) {
    return this.http.get<any>(`${environment.api.consumer}/customer/by-keycloak/${keycloakId}`);
  }

  saveIban(keycloakId: string, iban: string) {
    return this.http.post<any>(`${environment.api.consumer}/customer/by-keycloak/${keycloakId}?iban=${iban}`, {});
  }
}
